import { IFormatter } from '../FormatterTypes';
import { TEDDisplayCurr } from '../Displayers/TEDDisplayCurr';
import { TEDValidateDefault } from '../Validators/TEDValidateDefault';
import { TEDParseCurr } from '../Parsers/TEDParseCurr';

class TEDFormatCurr implements IFormatter {
  displayer = TEDDisplayCurr.getInstance();

  parser = TEDParseCurr.getInstance();

  validator = TEDValidateDefault.getInstance();
}

export { TEDFormatCurr };
